<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-md p-4 transition-opacity duration-300 animate-fade-in"
  [class.opacity-0]="!isVisible" [class.opacity-100]="isVisible" (click)="onClose()">

  <div
    class="bg-white dark:bg-slate-900/95 backdrop-blur-sm w-full max-w-2xl rounded-[2rem] shadow-2xl overflow-hidden transition-all duration-300 relative text-slate-800 dark:text-slate-200 border border-slate-100/50 dark:border-slate-800/50"
    [class.translate-y-4]="!isVisible" [class.translate-y-0]="isVisible" (click)="$event.stopPropagation()">

    <!-- Decorative Backdrop Blob for Glassmorphism highlight -->
    <div
      class="absolute top-10 right-10 w-44 h-44 bg-amber-400/10 dark:bg-amber-450/5 rounded-full blur-3xl pointer-events-none -z-10">
    </div>

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800/80">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-2xl bg-amber-400/10 dark:bg-amber-400/20 flex items-center justify-center text-amber-500 shadow-[0_0_15px_rgba(251,191,36,0.3)]">
          <span class="material-icons">{{ isEdit ? 'edit_note' : 'add_task' }}</span>
        </div>
        <div>
          <h2 class="text-lg font-extrabold text-slate-900 dark:text-white">
            {{ isEdit ? 'แก้ไขประเภทเรื่องปัญหา' : 'สร้างประเภทเรื่องปัญหาใหม่' }}
          </h2>
          <p class="text-[10px] text-slate-500 dark:text-slate-400 font-medium">
            กรอกข้อมูลรายละเอียดประเภทปัญหา และเงื่อนไขการทำงานสำหรับฝ่ายบริการลูกค้า
          </p>
        </div>
      </div>
      <button (click)="onClose()"
        class="w-8 h-8 flex items-center justify-center rounded-xl bg-slate-50 hover:bg-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors cursor-pointer border-none">
        <span class="material-icons text-sm">close</span>
      </button>
    </div>

    <!-- Modal Form Body -->
    <div class="p-6 space-y-5 max-h-[70vh] overflow-y-auto custom-scrollbar">

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <!-- Issue Code -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
            รหัสประเภทเรื่อง <span class="text-rose-500">*</span>
          </label>
          <div
            class="flex items-center border rounded-xl px-4 py-2.5 shadow-inset transition-all duration-300 focus-within:ring-2 focus-within:ring-amber-200"
            [ngClass]="{
              'bg-slate-200/50 dark:bg-slate-800/40 border-slate-200 dark:border-slate-700': isEdit && !formData.canEditCode,
              'bg-slate-100/30 dark:bg-slate-800 border-slate-100 dark:border-slate-700': !isEdit || formData.canEditCode
            }">
            <input type="text" [(ngModel)]="formData.code" placeholder="เช่น ticket_refund, sync_fail..."
              [disabled]="isEdit && !formData.canEditCode"
              class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200 disabled:text-slate-400 dark:disabled:text-slate-500" />
            <span *ngIf="isEdit && !formData.canEditCode" class="material-icons text-xs text-slate-400 ml-2"
              title="ไม่สามารถแก้ไขรหัสได้ เนื่องจากมีประวัติเคสใช้งานแล้ว">lock</span>
          </div>
        </div>

        <!-- Issue Name -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
            ชื่อประเภทเรื่อง (TH) <span class="text-rose-500">*</span>
          </label>
          <div
            class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
            <input type="text" [(ngModel)]="formData.name" placeholder="เช่น ขอเงินคืน, ปรับยอดเงินตกหล่น..."
              class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <!-- Category Dropdown (Searchable Combobox) -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">หมวดหมู่</label>
          <div class="relative">
            <div
              class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
              <input type="text" [(ngModel)]="searchCategoryText" (focus)="isCategoryDropdownOpen = true"
                (blur)="closeCategoryDropdown()" placeholder="เลือกหมวดหมู่..."
                class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
              <button type="button" (click)="toggleCategoryDropdown()"
                class="bg-transparent border-none outline-none cursor-pointer flex items-center">
                <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                  [class.rotate-180]="isCategoryDropdownOpen">expand_more</span>
              </button>
            </div>

            <!-- Fake Dropdown Menu -->
            <div *ngIf="isCategoryDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute top-full left-0 right-0 mt-2 z-50 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-xl py-1 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in">
              <button *ngFor="let opt of filteredCategories" (click)="selectCategory(opt)"
                class="w-full text-left px-4 py-2.5 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent font-medium">
                {{ opt.label }}
              </button>
              <div *ngIf="filteredCategories.length === 0" class="py-3 text-center text-xs text-slate-400 font-medium">
                ไม่พบหมวดหมู่ที่ตรงกัน
              </div>
            </div>
          </div>
        </div>

        <!-- Resolution Mode Dropdown (Searchable Combobox) -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">รูปแบบการแก้ไข</label>
          <div class="relative">
            <div
              class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
              <input type="text" [(ngModel)]="searchResolutionText" (focus)="isResolutionDropdownOpen = true"
                (blur)="closeResolutionDropdown()" placeholder="เลือกรูปแบบแก้ไข..."
                class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
              <button type="button" (click)="toggleResolutionDropdown()"
                class="bg-transparent border-none outline-none cursor-pointer flex items-center">
                <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                  [class.rotate-180]="isResolutionDropdownOpen">expand_more</span>
              </button>
            </div>

            <!-- Fake Dropdown Menu -->
            <div *ngIf="isResolutionDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute top-full left-0 right-0 mt-2 z-50 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-xl py-1 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in">
              <button *ngFor="let opt of filteredResolutionModes" (click)="selectResolution(opt)"
                class="w-full text-left px-4 py-2.5 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent font-medium">
                {{ opt.label }}
              </button>
              <div *ngIf="filteredResolutionModes.length === 0" class="py-3 text-center text-xs text-slate-400 font-medium">
                ไม่พบรูปแบบที่ตรงกัน
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <!-- SLA Hours -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
            เวลาดำเนินการเป้าหมาย (SLA ชั่วโมง)
          </label>
          <div
            class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
            <input type="number" [(ngModel)]="formData.defaultSlaHours" placeholder="เช่น 24, 48..."
              class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
            <span class="text-xs text-slate-400 font-bold ml-2">ชม.</span>
          </div>
        </div>

        <!-- Sort Order -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">ลำดับการแสดงผล</label>
          <div
            class="flex items-center bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 px-4 py-2.5 transition-all duration-300">
            <input type="number" [(ngModel)]="formData.sortOrder" placeholder="เช่น 10, 20..."
              class="w-full text-xs font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
          </div>
        </div>
      </div>

      <!-- Description -->
      <div class="space-y-2">
        <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wide">คำอธิบาย</label>
        <textarea [(ngModel)]="formData.description" placeholder="รายละเอียดเพิ่มเติมเกี่ยวกับประเภทเรื่องปัญหา..."
          rows="3"
          class="w-full text-xs font-semibold bg-slate-100/30 shadow-inset dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus:ring-2 focus:ring-amber-200 p-3 outline-none transition-all duration-300 resize-none text-slate-750 dark:text-slate-200"></textarea>
      </div>

      <!-- Flags Grid (Switches/Badges) -->
      <div class="bg-slate-50/50 dark:bg-slate-800/30 rounded-3xl p-5 border border-slate-100 dark:border-slate-800/80 space-y-4">
        <h3 class="text-xs font-extrabold text-slate-550 dark:text-slate-400 uppercase tracking-wider">เงื่อนไขการทำงานและสถานะ</h3>
        
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          <!-- Active -->
          <label class="flex items-center gap-3 cursor-pointer group select-none">
            <div class="relative">
              <input type="checkbox" [(ngModel)]="formData.active" class="sr-only peer" />
              <div class="w-10 h-6 bg-slate-200 dark:bg-slate-750 rounded-full peer peer-focus:ring-2 peer-focus:ring-amber-400/50 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-amber-400 peer-checked:after:border-amber-400"></div>
            </div>
            <span class="text-xs font-bold text-slate-650 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">
              เปิดใช้งาน (Active)
            </span>
          </label>

          <!-- Is Online -->
          <label class="flex items-center gap-3 cursor-pointer group select-none">
            <div class="relative">
              <input type="checkbox" [(ngModel)]="formData.isOnline" class="sr-only peer" />
              <div class="w-10 h-6 bg-slate-200 dark:bg-slate-750 rounded-full peer peer-focus:ring-2 peer-focus:ring-amber-400/50 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-amber-400 peer-checked:after:border-amber-400"></div>
            </div>
            <span class="text-xs font-bold text-slate-650 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">
              ออนไลน์ (Is Online)
            </span>
          </label>

          <!-- Customer Selectable -->
          <label class="flex items-center gap-3 cursor-pointer group select-none">
            <div class="relative">
              <input type="checkbox" [(ngModel)]="formData.customerSelectable" class="sr-only peer" />
              <div class="w-10 h-6 bg-slate-200 dark:bg-slate-750 rounded-full peer peer-focus:ring-2 peer-focus:ring-amber-400/50 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-amber-400 peer-checked:after:border-amber-400"></div>
            </div>
            <span class="text-xs font-bold text-slate-650 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">
              ลูกค้าเลือกเองได้
            </span>
          </label>

          <!-- Requires Refund -->
          <label class="flex items-center gap-3 cursor-pointer group select-none">
            <div class="relative">
              <input type="checkbox" [(ngModel)]="formData.requiresRefund" class="sr-only peer" />
              <div class="w-10 h-6 bg-slate-200 dark:bg-slate-750 rounded-full peer peer-focus:ring-2 peer-focus:ring-amber-400/50 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-amber-400 peer-checked:after:border-amber-400"></div>
            </div>
            <span class="text-xs font-bold text-slate-650 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">
              เรื่องขอคืนเงิน (Refund)
            </span>
          </label>

          <!-- Requires Approval -->
          <label class="flex items-center gap-3 cursor-pointer group select-none">
            <div class="relative">
              <input type="checkbox" [(ngModel)]="formData.requiresApproval" class="sr-only peer" />
              <div class="w-10 h-6 bg-slate-200 dark:bg-slate-750 rounded-full peer peer-focus:ring-2 peer-focus:ring-amber-400/50 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-amber-400 peer-checked:after:border-amber-400"></div>
            </div>
            <span class="text-xs font-bold text-slate-650 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">
              ต้องขออนุมัติ (Approval)
            </span>
          </label>
        </div>
      </div>

    </div>

    <!-- Modal Footer -->
    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800/80 flex flex-col-reverse sm:flex-row justify-between gap-3 bg-slate-50/50 dark:bg-slate-900/50">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50 bg-transparent">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 ml-auto w-full sm:w-auto">
        <button (click)="onClose()"
          class="px-5 py-2.5 rounded-2xl hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 font-bold text-sm cursor-pointer transition-colors border-none bg-transparent">
          ยกเลิก
        </button>
        <button (click)="onSave()" [disabled]="isSaving()"
          class="px-6 py-3.5 bg-amber-400 disabled:bg-slate-100 disabled:text-slate-400 hover:bg-amber-500 text-white font-black rounded-2xl text-sm cursor-pointer transition-all duration-300 hover:shadow-[0_8px_16px_-4px_rgba(251,191,36,0.5)] border-none">
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึกข้อมูล' }}
        </button>
      </div>
    </div>

  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && formData.id"
  [entityType]="activityEntityTypes.IssueType"
  [entityId]="formData.id!"
  title="ประวัติประเภทเรื่อง CS"
  [subtitle]="'#' + formData.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
